module.exports = __webpack_public_path__ + "static/media/polygonInactive.a5527563.png";